/* Lee'mail · thème v1.2 : interactions (cases, menu mobile, compte à rebours, CTA collant, révélations, offres club + panier mixte) */
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('.door'))) { el.classList.toggle('open'); el.setAttribute('aria-pressed', el.classList.contains('open')); return; }
    if ((el = t.closest('[data-action]'))) {
      var a = el.getAttribute('data-action');
      var scope = el.closest('section') || document;
      if (a === 'open-all') $$('.door', scope).forEach(function (d) { d.classList.add('open'); d.setAttribute('aria-pressed', 'true'); });
      else if (a === 'close-all') $$('.door', scope).forEach(function (d) { d.classList.remove('open'); d.setAttribute('aria-pressed', 'false'); });
      else if (a === 'menu') { var m = $('[data-menu]'); if (m) m.classList.add('open'); }
      else if (a === 'menu-close') { var m2 = $('[data-menu]'); if (m2) m2.classList.remove('open'); }
      else if (a === 'qty') {
        var input = document.getElementById(el.getAttribute('data-target'));
        if (input) { var v = (parseInt(input.value, 10) || 1) + parseInt(el.getAttribute('data-step'), 10); var max = parseInt(input.getAttribute('max'), 10) || 99; input.value = Math.max(1, Math.min(max, v)); }
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var m = $('[data-menu]'); if (m) m.classList.remove('open'); } });
  document.addEventListener('click', function (e) { var m = $('[data-menu]'); if (m && e.target === m) m.classList.remove('open'); });

  /* Compte à rebours en 2 phases : avant data-open -> "ouverture des précommandes" ;
     entre data-open et data-countdown -> "fin des précommandes" ; après -> message de fin. */
  function countdowns() {
    $$('[data-countdown]').forEach(function (cd) {
      if (cd._cdTimer) clearInterval(cd._cdTimer);
      var box = cd.closest('[data-cd-box]') || cd.parentNode;
      var open = new Date(cd.getAttribute('data-open') || '').getTime();
      var end = new Date(cd.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      function phase(now) { return (!isNaN(open) && now < open) ? 'before' : (now < end ? 'during' : 'after'); }
      function tick() {
        var now = Date.now(), ph = phase(now);
        box.setAttribute('data-phase', ph);
        $$('[data-phase-show]', box).forEach(function (el) { el.hidden = el.getAttribute('data-phase-show').split(' ').indexOf(ph) === -1; });
        var target = ph === 'before' ? open : end;
        var d = Math.max(0, target - now), s = Math.floor(d / 1000);
        var vals = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(vals).forEach(function (k) { var b = $('[data-cd="' + k + '"]', cd); if (b) b.textContent = String(vals[k]).padStart(2, '0'); });
        cd.hidden = ph === 'after';
      }
      tick(); cd._cdTimer = setInterval(tick, 1000);
    });
  }

  function reveals() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function sticky() {
    var s = $('[data-sticky]'), hero = $('.hero');
    if (!s || !hero || !('IntersectionObserver' in window)) return;
    var finalCta = $('.final-cta'), offersSec = $('#offres'), heroOut = false, finalIn = false, offersIn = false;
    function upd() { s.classList.toggle('show', heroOut && !finalIn && !offersIn); }
    new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting; upd(); }).observe(hero);
    if (finalCta) new IntersectionObserver(function (es) { finalIn = es[0].isIntersecting; upd(); }).observe(finalCta);
    if (offersSec) new IntersectionObserver(function (es) { offersIn = es[0].isIntersecting; upd(); }, { threshold: .1 }).observe(offersSec);
  }


  /* ===== Club Lee'mail : sélecteur d'offres, panier mixte (/cart/add.js + selling_plan), upsells ===== */
  var CFG = null;
  try { CFG = JSON.parse(document.getElementById('LeemailClub').textContent); } catch (e) { CFG = null; }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function fmt(c) { c = Math.round(c || 0); var e = Math.floor(c / 100), r = c % 100; return (r ? e + ',' + String(r).padStart(2, '0') : String(e)) + '\u00a0€'; }
  function addItems(items) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; }); });
  }
  function goCart(withCode) {
    var code = withCode === true ? (CFG && CFG.mailette && CFG.mailette.code) : withCode;
    if (code) location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart');
    else location.href = ROOT + 'cart';
  }
  function cleanProps(p) { var o = {}, n = 0; Object.keys(p || {}).forEach(function (k) { if (p[k]) { o[k] = p[k]; n++; } }); return n ? o : null; }
  function calItem(qty, props) { var it = { id: CFG.calendar.variant, quantity: qty || 1 }; props = cleanProps(props); if (props) it.properties = props; return it; }
  function subItem(kind, props) { var s = CFG[kind]; var it = { id: s.variant, quantity: 1, selling_plan: Number(s.plan) }; props = cleanProps(props); if (props) it.properties = props; return it; }
  function giftItem(props) { var it = { id: CFG.gift.variant, quantity: 1 }; props = cleanProps(props); if (props) it.properties = props; return it; }
  function planReady(kind) { return !!(CFG && CFG[kind] && CFG[kind].variant && CFG[kind].plan); }
  function busy(btn, on) { if (!btn) return; btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function showErr(el, msg) { if (!el) { alert(msg); return; } el.textContent = msg; el.hidden = false; }

  function offers(sec) {
    if (!CFG || sec._init) return; sec._init = true;
    var copy = {}; try { copy = JSON.parse($('[data-offer-copy]', sec).textContent); } catch (e) { return; }
    var state = { offer: copy['default'] || 'seul', copine: false, cadeau: false };
    var btn = $('[data-add-offer]', sec), err = $('[data-sum-error]', sec), pending = $('[data-sum-pending]', sec), giftFields = $('[data-gift-fields]', sec);
    var T3 = copy.trois || null;
    function yr() { return T3 ? { price: Number(T3.first) || 0 } : CFG.annual; }
    function yrReady() { return T3 ? !!(T3.variant && T3.plan) : planReady('annual'); }
    function m1Disc() { return (copy.m1_discount === 0 || copy.m1_discount) ? Number(copy.m1_discount) : CFG.mailette.discount; }
    function row(a, b, cls) { return '<div class="row ' + (cls || '') + '"><span>' + a + '</span><span style="text-align:right">' + b + '</span></div>'; }
    function render() {
      $$('[data-offer]', sec).forEach(function (o) { var on = o.getAttribute('data-offer') === state.offer; o.classList.toggle('selected', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var r = copy.rows, c = copy[state.offer], cal = CFG.calendar.price, total = cal, html = row(r.calendar, fmt(cal));
      if (state.offer === 'mensuel') { var m1 = CFG.monthly.price - m1Disc(); total += m1; html += row(r.month1, m1Disc() > 0 ? '<span class="strike">' + fmt(CFG.monthly.price) + '</span> <b>' + fmt(m1) + '</b>' : '<b>' + fmt(m1) + '</b>'); }
      if (state.offer === 'annuel') { total += yr().price; html += row(r.year, fmt(yr().price)); }
      if (state.copine) { var cp = cal - CFG.copine.discount; total += cp; html += row(r.copine, '<span class="strike">' + fmt(cal) + '</span> <b>' + fmt(cp) + '</b>'); }
      if (state.cadeau) { total += CFG.gift.price; html += row(r.gift, fmt(CFG.gift.price)); }
      html += row(r.shipping, r.shipping_value);
      html += row('<b>' + r.today + '</b>', '<b>' + fmt(total) + '</b>', 'total');
      if (state.offer === 'mensuel') html += row(r.then_month, '', 'then');
      if (state.offer === 'annuel') html += row(r.then_year, '', 'then');
      $('[data-sum-rows]', sec).innerHTML = html;
      $('[data-sum-title]', sec).textContent = c.title;
      $('[data-sum-note]', sec).textContent = c.note;
      var needPlan = state.offer === 'mensuel' ? 'monthly' : (state.offer === 'annuel' ? 'annual' : null);
      var ready = needPlan === 'annual' ? yrReady() : (needPlan ? planReady(needPlan) : true);
      var blocked = !ready || !CFG.calendar.available;
      if (pending) pending.hidden = ready;
      btn.disabled = blocked; btn.textContent = c.cta;
      if (giftFields) giftFields.hidden = !state.cadeau;
      if (err) err.hidden = true;
      var st = $('[data-sticky]'); if (st) { var b = $('b', st); if (b) b.textContent = c.title; }
    }
    sec.addEventListener('click', function (e) { var o = e.target.closest('[data-offer]'); if (o) { state.offer = o.getAttribute('data-offer'); render(); } });
    sec.addEventListener('keydown', function (e) { var o = e.target.closest && e.target.closest('[data-offer]'); if (o && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); state.offer = o.getAttribute('data-offer'); render(); } });
    sec.addEventListener('change', function (e) { var a = e.target.getAttribute('data-addon'); if (a) { state[a] = e.target.checked; render(); } });
    btn.addEventListener('click', function () {
      var items = [calItem(1)];
      if (state.offer === 'mensuel') items.push(subItem('monthly'));
      if (state.offer === 'annuel') items.push(T3 ? { id: Number(T3.variant), quantity: 1, selling_plan: Number(T3.plan) } : subItem('annual'));
      if (state.copine) items.push(calItem(1, { 'Cadeau': CFG.copine.label }));
      if (state.cadeau) { var p = {}; $$('[data-gift-prop]', sec).forEach(function (f) { p[f.getAttribute('data-gift-prop')] = f.value.trim(); }); items.push(giftItem(p)); }
      busy(btn, true);
      addItems(items).then(function () { goCart(state.offer === 'mensuel' ? m1Disc() > 0 : (state.offer === 'annuel' && T3 && T3.code) || false); }).catch(function (x) { busy(btn, false); showErr(err, x.message); });
    });
    render();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-add]'); if (!b || !CFG) return;
    e.preventDefault();
    var kind = b.getAttribute('data-cart-add'), items, mail = false;
    if (kind === 'club') { if (!planReady('monthly')) return; items = [subItem('monthly')]; mail = !!(CFG.mailette && CFG.mailette.discount > 0); }
    else if (kind === 'copine') items = [calItem(1, { 'Cadeau': CFG.copine.label })];
    else return;
    busy(b, true);
    addItems(items).then(function () { goCart(mail); }).catch(function (x) { busy(b, false); alert(x.message); });
  });

  /* Fiche produit : case « ajouter le club » -> calendrier + abonnement en un seul ajout */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!CFG || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var cb = f.querySelector('[data-pdp-club]'); if (!cb || !cb.checked || !planReady('monthly')) return;
    e.preventDefault();
    var q = parseInt((f.querySelector('[name=quantity]') || {}).value, 10) || 1;
    var btn = f.querySelector('[type=submit]'); busy(btn, true);
    addItems([{ id: parseInt(f.querySelector('[name=id]').value, 10), quantity: q }, subItem('monthly')]).then(function () { goCart(!!(CFG.mailette && CFG.mailette.discount > 0)); })
      .catch(function (x) { busy(btn, false); showErr(f.querySelector('[data-form-error]'), x.message); });
  });

  /* Page club : formule mensuelle ou annuelle + mois de naissance (propriété de ligne) */
  function clubCard(card) {
    if (!CFG || card._init) return; card._init = true;
    var btn = $('[data-club-join]', card), err = $('[data-club-error]', card), pend = $('[data-club-pending]', card);
    function kind() { var r = $('input[name="club-formula"]:checked', card); return r ? r.value : 'monthly'; }
    function t3Ready() { return !!(CFG.trois && CFG.trois.variant && CFG.trois.plan); }
    function upd() {
      var k = kind(), ok = k === 'trois' ? t3Ready() : planReady(k);
      btn.disabled = !ok; if (pend) pend.hidden = ok;
      $$('[data-show-formula]', card).forEach(function (el) { el.hidden = el.getAttribute('data-show-formula') !== k; });
      $$('[data-hide-formula]', card).forEach(function (el) { el.hidden = el.getAttribute('data-hide-formula') === k; });
    }
    card.addEventListener('change', upd);
    btn.addEventListener('click', function () {
      var k = kind(), props = {}, bm = $('[data-birth-month]', card);
      if (k !== 'trois' && bm && bm.value) props[bm.getAttribute('data-birth-month')] = bm.value;
      if (k === 'trois' ? !t3Ready() : !planReady(k)) return;
      var it = k === 'trois' ? { id: Number(CFG.trois.variant), quantity: 1, selling_plan: Number(CFG.trois.plan) } : subItem(k);
      var cp = cleanProps(props); if (cp) it.properties = cp;
      busy(btn, true);
      addItems([it]).then(function () { goCart(k === 'trois' ? (CFG.trois.code || false) : false); }).catch(function (x) { busy(btn, false); showErr(err, x.message); });
    });
    upd();
  }
  function clubInit() { $$('[data-offers-section]').forEach(offers); $$('[data-club-card]').forEach(clubCard); }

  function init() { countdowns(); reveals(); sticky(); clubInit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
